import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth';
import {
  getFirestore,
  connectFirestoreEmulator,
  Firestore
} from 'firebase/firestore';
import {
  getStorage,
  connectStorageEmulator,
  FirebaseStorage
} from 'firebase/storage';
import {
  getFunctions,
  connectFunctionsEmulator,
  Functions
} from 'firebase/functions';
import { getConfig } from '../utils/getConfig';
import { getFirebaseConfig } from './config';

let emulatorsConnected = false;

/** Connect SDK instances to the local emulator suite. Idempotent. */
function connectEmulators(
  auth: Auth,
  db: Firestore,
  storage: FirebaseStorage,
  functions: Functions
) {
  if (emulatorsConnected) return;
  const host = getConfig('FIREBASE_EMULATOR_HOST') || 'localhost';
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, host, 8080);
  connectStorageEmulator(storage, host, 9199);
  connectFunctionsEmulator(functions, host, 5001);
  emulatorsConnected = true;
}

function createApp(): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(getFirebaseConfig());
}

export const app: FirebaseApp = createApp();
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
// Cloud Functions (capability-token sketch sharing). Must match the functions' deployed region.
export const functions: Functions = getFunctions(app, 'us-central1');

if (getConfig('FIREBASE_USE_EMULATOR', { warn: false }) === 'true') {
  connectEmulators(auth, db, storage, functions);
}
